import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ModalShellComponent, ModalShellConfig } from '@shared/components/modal-shell/modal-shell.component';

export type RelationshipSyncDialogResult = 'both' | 'current' | 'cancel';

export interface RelationshipSyncDialogData {
  relatedPersonName: string;
  canUpdateRelatedPerson: boolean;
}

@Component({
  selector: 'app-relationship-sync-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, ModalShellComponent],
  templateUrl: './relationship-sync-dialog.component.html',
  styleUrl: './relationship-sync-dialog.component.scss',
})
export class RelationshipSyncDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<RelationshipSyncDialogComponent, RelationshipSyncDialogResult>);
  selectedResult: Exclude<RelationshipSyncDialogResult, 'cancel'> | null = null;
  readonly modalConfig: ModalShellConfig = {
    title: 'Actualizar relación de pareja',
    size: 'sm',
    layout: 'confirm',
  };

  constructor(@Inject(MAT_DIALOG_DATA) public readonly data: RelationshipSyncDialogData) {}

  close(result: RelationshipSyncDialogResult): void {
    this.dialogRef.close(result);
  }

  select(result: Exclude<RelationshipSyncDialogResult, 'cancel'>): void {
    this.selectedResult = result;
  }

  continue(): void {
    if (this.selectedResult) {
      this.dialogRef.close(this.selectedResult);
    }
  }
}
